// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"38838304","977":"bcbd12b6"}[chunkId] + ".chunk.js";
};